import script from "./ReaderInfoTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ReaderInfoTabs.vue?vue&type=script&setup=true&lang=js"

import "./ReaderInfoTabs.vue?vue&type=style&index=0&id=c94ef85c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c94ef85c"]])

export default __exports__